import { render, staticRenderFns } from "./eval-detail-2.vue?vue&type=template&id=77f66b1b"
import script from "./eval-detail-2.vue?vue&type=script&lang=js"
export * from "./eval-detail-2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports